module.exports = __webpack_public_path__ + "static/media/tygge.3cf3aac2.m4a";